/* eslint-disable */
import axios from 'axios';
import { config } from '../config/config'; // eslint-disable-next-line
axios.interceptors.request.use(
	function(config) {
		return config;
	},
	function(error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	function(response) {
		return response;
	},
	function(error) {
		return Promise.reject(error);
	}
);


export const copiriPortalRequest = async (url, app_version, method, data = '') => {
	let token = localStorage.getItem('palaver');
	if (data !== '') {
		return await axios({
			method: method,
			url: config.api_url + url,
			data: data,
			withCredentials: true,
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': 'multipart/form-data'
				//'Content-Type' : 'application/x-www-form-urlencoded',
			}
		});
	} else {
		return await axios({
			method: method,
			withCredentials: true,
			url: config.api_url + url,
			headers: {
				//Authorization: 'Bearer ' + token,
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	}
};

export function getLanguagePackUrl() {
	let url = '';
	url = '/web/wcrmgl/language';
	return url;
}
